module.exports = __webpack_public_path__ + "img/icon-external-link.7b351b90.svg";